import { render, staticRenderFns } from "./ArticoloResiduo.vue?vue&type=template&id=49426f38&scoped=true&"
import script from "./ArticoloResiduo.vue?vue&type=script&lang=js&"
export * from "./ArticoloResiduo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49426f38",
  null
  
)

export default component.exports